module.exports = __webpack_public_path__ + "static/media/The_Spiritual_Beast.88da94b6.jpeg";